import { createAsyncThunk } from '@reduxjs/toolkit';
import { GuestApi } from '../../api/base/Guest';

export const fetchCurrentGuestData = createAsyncThunk<
  // Return type of the payload creator
  any,
  // First argument to the payload creator
  number,
  {
    rejectValue: any;
  }
>('currentGuest/fetchGuest', async (guestId, thunkApi) => {
  try {
    const response = await GuestApi.getGuest(guestId);
    return response.data.data;
  } catch (error) {
    return thunkApi.rejectWithValue({
      data: error.response.data,
      statusCode: error.response.status,
    });
  }
});
